import { autoUpdate, flip, offset, Placement, shift, UseFloatingProps } from '@floating-ui/react-dom-interactions';

export enum ActivePopoverType {
  DATE = 'date',
  TIME = 'time',
  NONE = 'none',
}

export const getDefaultDateInputFloatingProps = (placement: Placement): Partial<UseFloatingProps> => ({
  placement,
  middleware: [offset(6), flip({ fallbackStrategy: 'bestFit' }), shift()],
  whileElementsMounted: autoUpdate,
});
